module.exports = __webpack_public_path__ + "static/empty-states-body-dont-870461fe826b2e9d675d5738c73a92b7.png";